"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EventDispatcher = _interopRequireDefault(require("../event/EventDispatcher"));

var _InfoPanelView = _interopRequireDefault(require("./views/InfoPanelView"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var formatControlOpts = function (opts, overrides) {
  return (0, _utils.extend)({}, opts, overrides);
};
/**
 * A module manager is responsible for managing a series of modules associated with an application.
 *
 * @class ModuleManager
 */


var ModuleManager =
/** @class */
function (_super) {
  __extends(ModuleManager, _super);
  /**
   * Initializes a module manager with the specified application.
   *
   * @param {InteractiveMapApp} app
   * @memberof ModuleManager
   */


  function ModuleManager(app) {
    var _this = _super.call(this) || this;

    _this._moduleLegendCache = {};
    _this._app = app;
    _this._modules = {};
    return _this;
  }
  /**
   * Adds a module to the application.
   *
   * The specified module must either be an instance of a class that implements the
   * `IMapSourceModule` interface or a loader function that loads and initializes the module
   * on-demand.
   *
   * @param {IMapSourceModule} module
   * @param {*} [overrides=null]
   * @returns
   * @memberof ModuleManager
   */


  ModuleManager.prototype.add = function (module, overrides, constructorOpts) {
    var _this = this;

    if (overrides === void 0) {
      overrides = null;
    }

    if (constructorOpts === void 0) {
      constructorOpts = null;
    }

    if (!(0, _utils.isset)(module)) {
      console.error("[Aeris] Invalid module specified, received " + module);
      return;
    } // setup a module group if the provided module is an instance of ModuleGroup


    if ((0, _utils.has)(module, 'id') && (0, _utils.has)(module, 'load')) {
      this.addGroup(module, overrides);
      return;
    } // determine if we're loading in a pre-built module from the library, which we then need
    // to load and then create an instance of before adding


    if ((0, _utils.isFunction)(module)) {
      module().then(function (Module) {
        Module = Module.default || Module;

        if (!(0, _utils.isPlainObject)(Module)) {
          _this.add(new Module(constructorOpts), overrides);
        } else {
          console.error('[Aeris] Module is not a valid class.');
        }
      }).catch(function (e) {
        console.error('[Aeris] Failed to load built-in module', e);
      });
      return;
    }

    if ((0, _utils.isEmpty)(module.id)) {
      throw new Error('[Aeris] Map modules must provide a unique identifier using the `id` property.');
    }

    if ((0, _utils.has)(module, 'initialize') === false) {
      throw new Error("[Aeris] Cannot add invalid map module " + module.id + ". Modules must implement the IMapSourceModule interface and its required methods.");
    }

    this._modules[module.id] = module;
    module.initialize(this._app.account, this._app); // finish setting up module only once the app is ready

    this._onAppReady(function () {
      var _a = overrides || {},
          source = _a.source,
          controls = _a.controls,
          legend = _a.legend,
          infopanel = _a.infopanel;

      var sourceOpts = (0, _utils.extend)({}, module.source(), (0, _utils.isFunction)(source) ? source() : source);
      var legendOpts = (0, _utils.extend)({}, module.legend(), legend);
      var infoPanelOpts = (0, _utils.extend)({}, module.infopanel(), infopanel);
      var controlOpts = formatControlOpts(module.controls(), controls);

      if (!(0, _utils.isset)(sourceOpts) || (0, _utils.isEmpty)(sourceOpts)) {
        throw new Error("[Aeris] Cannot add map module " + module.id + ", a valid map content source was not provided.");
      } // setup module controls first before adding its source so that initial state selection
      // on the controls will be set properly


      if (!module.group) {
        _this._setupControls(module.id, controlOpts);
      }

      _this._setupLegends(module.id, legendOpts);

      _this._setupInfoPanel(module.id, infoPanelOpts);

      var dataSource = _this._setupSource(module.id, sourceOpts);

      module.dataSource = dataSource;

      _this._setupModuleEvents(module);

      _this.trigger('module:load', {
        id: module.id,
        module: module
      });
    });
  };
  /**
   * Adds a module to the application and inserts its control at the specified index.
   *
   * The specified module must either be an instance of a class that implements the
   * `IMapSourceModule` interface or a loader function that loads and initializes the module
   * on-demand.
   *
   * @param index
   * @param module
   * @param overrides
   */


  ModuleManager.prototype.insertAt = function (index, module, overrides, constructorOpts) {
    if (overrides === void 0) {
      overrides = null;
    }

    if (constructorOpts === void 0) {
      constructorOpts = null;
    }

    this.add(module, (0, _utils.extend)(overrides, {
      controls: {
        index: index
      }
    }), constructorOpts);
  };
  /**
   * Adds a module group to the application.
   *
   * @param {ModuleGroup} group
   * @param {*} [overrides=null]
   * @memberof ModuleManager
   */


  ModuleManager.prototype.addGroup = function (group, overrides) {
    var _this = this;

    if (overrides === void 0) {
      overrides = null;
    }

    overrides = overrides || {};
    group.load().then(function (modules) {
      // const moduleControls = modules.map((m) => m.controls());
      // const groupControls = group.controls();
      // if (groupControls) {
      // 	groupControls.id = groupControls.id || group.id;
      // 	if (isPlainObject(groupControls)) {
      // 		if (isArray(groupControls.buttons)) {
      // 			groupControls.buttons = groupControls.buttons.concat(moduleControls);
      // 		} else {
      // 			groupControls.buttons = moduleControls;
      // 		}
      // 	} else if (isArray(groupControls)) {
      // 		groupControls.concat(moduleControls);
      // 	}
      // 	this._setupControls(group.id, groupControls);
      // }
      if ((0, _utils.has)(group, 'initialize')) {
        group.initialize(_this._app.account, _this._app);
      }

      _this._onAppReady(function () {
        var controls = group.controls();

        if (controls) {
          var controlOverrides = overrides.controls;
          var controlOpts = formatControlOpts(controls, controlOverrides);

          _this._setupControls(group.id, controlOpts);
        }

        _this._setupGroupEvents(group);
      });

      var moduleOverrides = overrides.modules || {};
      modules.forEach(function (m) {
        m.group = group;

        _this.add(m, moduleOverrides[m.id]);
      });
    }).catch(function (error) {
      console.error('[Aeris] Module group failed to load - ERROR', error);
    });
  };
  /**
   * Removes a module from the application.
   *
   * @param {IMapSourceModule} module
   * @memberof ModuleManager
   */


  ModuleManager.prototype.remove = function (module) {
    var map = this._app.map;
    var source = map.getSourceForId(module.id);

    if (source) {
      map.removeSource(source);
    }

    delete this._modules[module.id];
    this.trigger('module:unload', {
      id: module.id,
      module: module
    });
  };

  ModuleManager.prototype.removeById = function (identifier) {
    var _this = this;

    var module;
    Object.keys(this._modules).forEach(function (id) {
      if (id === identifier) {
        module = _this._modules[id];
      }
    });

    if (module) {
      this.remove(module);
    }
  };

  ModuleManager.prototype._onAppReady = function (callback) {
    if (!callback) return;

    if (this._app.isReady()) {
      callback();
    } else {
      this._app.on('ready', function () {
        return callback();
      });
    }
  };

  ModuleManager.prototype._setupSource = function (id, opts) {
    if (opts) {
      var type = opts.type,
          rest = __rest(opts, ["type"]);

      return this._app.addSource(id, type, rest);
    }

    throw new Error("[Aeris] Cannot add module " + id + ", source is invalid.");
  };

  ModuleManager.prototype._setupControls = function (id, opts) {
    if (!opts) return;

    var layersPanel = this._app.getPanel('layers');

    if (layersPanel) {
      var index = opts.index;
      var config = (0, _utils.extend)({}, opts, {
        id: id
      });

      if ((0, _utils.isset)(index)) {
        delete config.index;
        layersPanel.insertAt(index, config);
      } else {
        layersPanel.add(config);
      }
    }
  };

  ModuleManager.prototype._setupLegends = function (id, opts) {
    var _this = this;

    if (!opts) return;

    var legendsPanel = this._app.getPanel('legends');

    if (legendsPanel) {
      var map = this._app.map;

      var layersPanel = this._app.getPanel('layers');

      var removeModuleLegend_1 = function (moduleId) {
        legendsPanel.legend.remove(_this._moduleLegendCache[moduleId]);
        delete _this._moduleLegendCache[moduleId];
      };

      var addModuleLegend_1 = function (moduleId) {
        var _a = (0, _utils.isset)(opts.get) && (0, _utils.isFunction)(opts.get) ? opts.get() : opts,
            title = _a.title,
            url = _a.url,
            code = _a.code;

        if (code === _this._moduleLegendCache[moduleId]) {
          return;
        }

        removeModuleLegend_1(moduleId);

        if ((0, _utils.isset)(code)) {
          legendsPanel.legend.add(code, {
            account: _this._app.account,
            within: {
              bounds: _this._app.map.getBounds()
            },
            title: title
          });
          _this._moduleLegendCache[id] = code;
        } else if ((0, _utils.isset)(url)) {
          legendsPanel.legend.add(id, {
            type: 'image',
            title: title,
            url: url
          });
          _this._moduleLegendCache[id] = id;
        }
      };

      map.on('source:add', function (e) {
        var addedId = (0, _utils.get)(e.data, 'id');

        if (id === addedId) {
          addModuleLegend_1(id);
        }
      }).on('source:remove', function (e) {
        var removedId = (0, _utils.get)(e.data, 'id');

        if (id === removedId) {
          removeModuleLegend_1(id);
        }
      });

      if (layersPanel) {
        layersPanel.on('change', function (e) {
          var changedId = (0, _utils.get)(e.data, 'id');

          if (id === changedId) {
            addModuleLegend_1(id);
          }
        });
      }
    }
  };

  ModuleManager.prototype._setupInfoPanel = function (id, opts) {
    if (!opts) return;
    var sections = opts.sections,
        view = opts.view;

    var infoPanel = this._app.getPanel('info');

    if (infoPanel) {
      if (sections || view) {
        if (sections) {
          Object.keys(sections).forEach(function (key) {
            return _InfoPanelView.default.setSection(key, sections[key]);
          });
        }

        if (view) {
          infoPanel.setContentView(id, view);
        }
      } else {
        infoPanel.setContentView(id, opts);
      }
    }
  };

  ModuleManager.prototype._setupModuleEvents = function (module) {
    var map = this._app.map;

    if ((0, _utils.has)(module, 'onAdd')) {
      map.on('source:add', function (e) {
        var id = (0, _utils.get)(e.data, 'id');

        if (id === module.id) {
          module.onAdd();
        }
      });
    }

    if ((0, _utils.has)(module, 'onRemove')) {
      map.on('source:remove', function (e) {
        var id = (0, _utils.get)(e.data, 'id');

        if (id === module.id) {
          module.onRemove();
        }
      });
    }

    if ((0, _utils.has)(module, 'onMarkerClick')) {
      map.on('marker:click', function (e) {
        var element = e.data.marker;
        var data = e.data.data || {};
        var source = data.awxjs_source;

        if (source === module.id) {
          module.onMarkerClick(element, data);
        }
      });
    }

    if ((0, _utils.has)(module, 'onShapeClick')) {
      map.on('shape:click', function (e) {
        var element = e.data.shape;
        var data = e.data.data || {};
        var source = data.awxjs_source;

        if (source === module.id) {
          module.onShapeClick(element, data);
        }
      });
    }

    if ((0, _utils.has)(module, 'onInit')) {
      module.onInit();
    }
  };

  ModuleManager.prototype._setupGroupEvents = function (module) {
    var map = this._app.map;
    var ids = module.modules.map(function (m) {
      return m.id;
    }); // include ids/values from group controls

    var controls = module.controls();

    if (controls && controls.buttons) {
      (controls.buttons || []).forEach(function (control) {
        var id = control.id || control.value;

        if (ids.indexOf(id) === -1) {
          ids.push(id);
        }
      });
    }

    if ((0, _utils.has)(module, 'onMarkerClick')) {
      map.on('marker:click', function (e) {
        var element = e.data.marker;
        var data = e.data.data || {};
        var source = data.awxjs_source;

        if (ids.indexOf(source) >= 0) {
          module.onMarkerClick(element, data);
        }
      });
    }

    if ((0, _utils.has)(module, 'onShapeClick')) {
      map.on('shape:click', function (e) {
        var element = e.data.shape;
        var data = e.data.data || {};
        var source = data.awxjs_source;

        if (ids.indexOf(source) >= 0) {
          module.onShapeClick(element, data);
        }
      });
    }

    if ((0, _utils.has)(module, 'onInit')) {
      module.onInit();
    }
  };

  return ModuleManager;
}(_EventDispatcher.default);

var _default = ModuleManager;
exports.default = _default;
module.exports = exports.default;